module.exports = __webpack_public_path__ + "f32cfbf14564d83f92154f763405b8e0.png";